module.exports = __webpack_public_path__ + "static/media/catalog-un-active.f9f84024.svg";